import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMinusMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="minus-medium, remove, delete" maskId="round-filled-radius-0-stroke-1.5-IconMinusMedium"><path fillRule="evenodd" clipRule="evenodd" d="M4.5 12C4.5 11.5858 4.77982 11.25 5.125 11.25H18.875C19.2202 11.25 19.5 11.5858 19.5 12C19.5 12.4142 19.2202 12.75 18.875 12.75H5.125C4.77982 12.75 4.5 12.4142 4.5 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMinusMedium;
